import { cmsDefaultRouterOptions } from '~dsc/utils/cms-default-router-options';

export default cmsDefaultRouterOptions;
